import { useEffect } from "react";
import ApiClient from "../api/client";
import { useStatusStore } from "../stores/status-store";
import { Status } from "../stores/types";
import APIUtils from "../api/APIUtils";

export const orderStatusColor = {
    1: "yellow-warning",
    2: "light-blue-warning",
    3: "light-green-warning",
    4: "grey-warning",
    5: "red-warning",
  }

const useStatus = () => {
    const { getStatuses, setStatuses, clearStatuses } = useStatusStore();

    useEffect(() => {
        const apiClient = new ApiClient(process.env.REACT_APP_AWS_URL);

        const fetchStatuses = async () => {
            const response = await apiClient.get<{ items: Array<Status>}>(`/${APIUtils.GATE_API}/NAGCO/orderstatus`, {
                headers: await APIUtils.getAuthorizationHeader(),
            });
            if (response.success && response.data) {
                const statusMap = response.data.items.reduce((acc, status) => {
                    acc[status.orderStatusCode] = {
                        orderStatusSequence: status.orderStatusSequence,
                        orderStatusText: status.orderStatusText,
                    };
                    return acc;
                }, {} as Record<number, { orderStatusSequence: number; orderStatusCode: string; orderStatusText: string }>);
                setStatuses(statusMap);
            }
        };

        if (!Object.keys(getStatuses()).length) {
            fetchStatuses();
        }

    }, [getStatuses, setStatuses, clearStatuses]);

    return {
        statuses: getStatuses(),
    };
};

export default useStatus;